<template>
  <div data-testid="emd-frame" :class="[
    'emd-frame',
    { _color_primary: active },
    { 'emd-frame__button__top' : buttonPosition === 'top'},
    { 'emd-frame__button__bottom' : buttonPosition === 'bottom'}
  ]">
    <div class="emd-frame__content">
      <div class="emd-frame__title">
        <h2>{{ title }}</h2>
        <span
          v-for="badge in badges"
          :key="badge.label"
          :class="['emd-badge', theme(badge.theme)]"
        >
          {{ badge.label }}
        </span>
      </div>
      <div class="emd-frame__text">
        <p v-html="text"></p>
      </div>
    </div>
    <div
      v-if="!buttonHide"
      class="emd-frame__button"
      data-testid="emd-frame-wrapper-button"
    >
      <button
        @click="handleClick"
        :class="[
          'emd-btn',
          { _color_primary: buttonPosition === 'middle'},
          { _type_text: buttonPosition !== 'middle'}
        ]"
        :disabled="disabled"
        data-testid="emd-frame-button"
        type="button"
      >
        {{ buttonLabel }}
      </button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'EmdFrame',
  props: {
    badges: {
      type: Array,
      default: () => [],
      required: false
    },
    title: {
      type: String,
      default: '',
      required: true
    },
    active: {
      type: Boolean,
      default: false,
      required: false
    },
    text: {
      type: String,
      default: '',
      required: true
    },
    'button-label': {
      name: 'buttonLabel',
      type: String,
      default: '',
      required: false
    },
    'button-hide': {
      name: 'buttonHide',
      type: Boolean,
      default: false,
      required: false
    },
    'button-position': {
      name: 'buttonPosition',
      type: String,
      default: 'middle',
      required: false,
      validator: (value) => {
        return ['middle', 'bottom', 'top'].includes(value)
      }
    },
    disabled: {
      name: 'disabled',
      type: Boolean,
      default: false,
      required: false
    }
  },
  methods: {
    handleClick (e) {
      e.preventDefault()
      this.$emit(e.type)
    },
    theme (theme) {
      return `_color_${theme}`
    }
  }
}
</script>
